<section id="market-seo">
  <div style="background: #F9F9F9;" class="pt-4 pt-md-0">
    <div id="mainBannerMarketWalmart" class="mx-4 mx-md-0">
      <div
        class="mainBanner-container position-relative d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-xxl-around px-4 pt-4">

        <div id="download-apps-top" class="d-flex flex-column align-items-center align-items-md-start pl-lg-5 pr-xl-5" style="flex:60%">

          <h1 class="h2 font-weight-bold  Poppins text-center text-md-left" style="text-transform: unset"><span>Compra fácil en </span><br>
          </h1>
          <img alt="Walmart" class="d-block d-md-none" width="200" src="assets/market-walmart/walmart.svg"/>
          <img alt="Walmart" class="d-none d-md-block d-lg-none" width="256" src="assets/market-walmart/walmart.svg"/>
          <img alt="Walmart" class="d-none d-lg-block d-xl-none" width="356" src="assets/market-walmart/walmart.svg"/>
          <img alt="Walmart" class="d-none d-xl-block" width="516" src="assets/market-walmart/walmart.svg"/>
          <span class="h2 font-weight-bold  Poppins text-center text-white text-uppercase d-block d-md-none" style="text-transform: unset; font-size: 20px"><span>Recibe rápido en Cuba</span></span>
          <img class="d-block d-md-none mr-4" width="212" src="assets/market-walmart/walmart-bag.png"
               alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
          <div class="d-flex justify-content-md-start justify-content-center"><button (click)="getWalmartProducts()" routerLink="../../../productos-compras-cuba-online"
                                                                                      class="btn mb-3 my-md-3 px-5 py-2 font-weight-bold OpenSans rounded-pill product-button"
                                                                                      style="background: #FFC222; font-size: 20px;color:#3C6DD0">
            Comprar Ahora
          </button></div>
          <!--<div class="w-100 d-block d-md-none" style="height: 186px">
            <img style="right: 0" class="mr-md-5 position-absolute d-block d-md-none" width="90" src="assets/market-walmart/background-logo.svg"
                 alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
            <img class="d-flex d-md-none position-absolute" width="220" src="assets/market-walmart/walmart_bags.png"
                 alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
            <img style="left: 0" class="position-absolute d-block d-md-none" width="50" src="assets/market-walmart/cubatel_logo.svg"
                 alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
          </div>-->


        </div>

        <img style="right: 0" class="mr-md-5 position-absolute d-none d-md-block d-lg-none" width="90" src="assets/market-walmart/background-logo.svg"
             alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        <img style="right: 0" class="mr-md-5 position-absolute d-none d-lg-block d-xl-none" width="130" src="assets/market-walmart/background-logo.svg"
             alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        <img style="right: 0" class="mr-md-5 position-absolute d-none d-xl-block" width="200" src="assets/market-walmart/background-logo.svg"
             alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        <img style="bottom: 0" class="mb-md-5 position-absolute d-none d-md-50 d-md-block d-lg-none" width="50" src="assets/market-walmart/cubatel_logo.svg"
             alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        <img style="bottom: 0" class="mb-md-5 position-absolute d-none d-lg-block" width="90" src="assets/market-walmart/cubatel_logo.svg"
             alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        <div class="d-none d-md-flex position-absolute" style="right: 10%; bottom: 0">
          <img class="mr-md-5 d-none d-md-block d-lg-none" width="220" src="assets/market-walmart/walmart_bags.png"
               alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
          <img class="mr-md-5 d-none d-lg-block d-xl-none" width="320" src="assets/market-walmart/walmart_bags.png"
               alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
          <img class="mr-md-5 d-none d-xl-block" width="450" src="assets/market-walmart/walmart_bags.png"
               alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        </div>
      </div>
    </div>
  </div>
  <!--END-MAIN-BANNER-->

  <!--PRODUCTS SECTION-->
  <app-products-walmart></app-products-walmart>
  <!--END PRODUCTS SECTION-->

  <!--MOST POPULAR PRODUCTS SECTION-->
  <app-most-popular-products [term]="mostPopularProducts(['Ropa', 'ropa de niño', 'shous'])" [title]="'Más buscados de Walmart en Cubatel'"></app-most-popular-products>
  <!--END MOST POPULAR PRODUCTS SECTION-->

  <!--MOST POPULAR PRODUCTS SECTION-->
  <app-most-popular-products [term]="mostPopularProducts(['Hogar y Cocina', 'pots', 'knifes set','cooking containers'])" [title]="'Mejor valorados de Walmart en Cubatel'"></app-most-popular-products>
  <!--END MOST POPULAR PRODUCTS SECTION-->

  <!--SHIPPING SECTION-->
  <app-shipping-amazon-section [title]="'Formas de enviar tus compras de Walmart a Cuba'" [provider]="ProviderType.Walmart"></app-shipping-amazon-section>
  <!--END SHIPPING SECTION-->

  <!--STEPS WALMART SECTION-->
  <app-step-walmart-section></app-step-walmart-section>

  <!--END STEP WALMART SECTION-->

  <!--FAQS SECTION-->
  <section id="market-list-faq" class="d-flex justify-content-center p-0 paginated ">
    <div class="container">
      <div class="row py-4">
        <div class="col-md-12 d-flex flex-column">
          <h2 class="p-2 font-weight-bold text-center with-line section-title">Preguntas frecuentes</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <article class="col-12 col-lg-12 col-md-12">
            <div class="accordion" id="faq">
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-0" data-toggle="collapse" data-target="#collapse-comida-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-0" aria-expanded="false" aria-controls="collapse-comida-0">
                      ¿Cuántas libras puedo enviar por paquetería a Cuba?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-0" class="collapse" aria-labelledby="heading-comida-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " >
                      En el caso de medicamentos, misceláneas y aseo personal, una persona en Cuba puede recibir hasta 100 libras en un mismo envío.<br>
                      En caso de bienes duraderos, el límite es de 500 puntos por envío sin importar el peso.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-1" data-toggle="collapse" data-target="#collapse-comida-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-1" aria-expanded="false" aria-controls="collapse-comida-1">
                      ¿Recibiré una factura de mi compra?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-1" class="collapse" aria-labelledby="heading-comida-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Sí, al momento de completar su compra, Cubatel le enviará un email con los detalles de su orden.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-2" data-toggle="collapse" data-target="#collapse-comida-2" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-1" aria-expanded="false" aria-controls="collapse-comida-2">
                      ¿Puedo cancelar mi orden?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-2" class="collapse" aria-labelledby="heading-comida-2" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Sí, tiene un plazo de 24 horas para cancelar su orden. Después de ese tiempo, la cancelación no es posible.<br>
                      Tenga en cuenta que su paquete pasará por aduanas, contenedores, barcos...  Una vez que se inicia ese proceso, es imposible para nosotros intervenir para cancelar su envío.<br>
                      Por esa razón requerimos que, al momento de completar su orden, acepte y verifique que entiende nuestros Términos y Condiciones.

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-3" data-toggle="collapse" data-target="#collapse-comida-3" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-3" aria-expanded="false" aria-controls="collapse-comida-3">
                      ¿Qué información necesito proveer para enviar un paquete a Cuba?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-3" class="collapse" aria-labelledby="heading-comida-3" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Para que su envío pueda ser entregado exitosamente y cumpla con los requisitos aduanales de Cuba y Estados Unidos, todos los datos deben ser reales y fidedignos. Cubatel no se responsabiliza por la entrega de paquetes que se envíen con información falsa. La información que necesitará proveer es la siguiente:<br>
                      Del remitente:<br>
                      &nbsp;- Nombre(s) y apellidos<br>
                      &nbsp;- Dirección completa de residencia<br>
                      &nbsp;- Teléfono<br>
                      &nbsp;- Aceptación de términos y condiciones<br>
                      Del receptor:<br>
                      &nbsp; - Nombre(s) y apellidos<br>
                      &nbsp; - Número de carné de identidad cubano<br>
                      &nbsp; - Dirección completa de residencia<br>
                      &nbsp; - Teléfono (se recomienda que sea un número de teléfono celular)
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-4" data-toggle="collapse" data-target="#collapse-comida-4" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-4" aria-expanded="false" aria-controls="collapse-comida-4">
                      ¿Entregan a domicilio?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-4" class="collapse" aria-labelledby="heading-comida-4" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Las entregas se hacen en la puerta de la casa de quien haya indicado como destinatario de su envío. Llegamos a todos los municipios de Cuba.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-5" data-toggle="collapse" data-target="#collapse-comida-5" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-5" aria-expanded="false" aria-controls="collapse-comida-5">
                      ¿Cuántos días demora el paquete en llegar a su destino?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-5" class="collapse" aria-labelledby="heading-comida-5" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Una vez Amazon entregue el paquete en nuestro almacén, comienza el proceso de envío por nuestra parte.<br>
                      En estos momentos disponemos de dos tipos de envíos:<br>
                      &nbsp; - Vía aérea: la entrega demora entre 7 y 15 días hábiles, una vez llegue el paquete a Cuba.<br>
                      &nbsp; - Vía marítima:  la entrega demora entre 15 y 35 días hábiles, una vez llegue el paquete a Cuba<br>
                      Es importante destacar que en el Municipio Especial Isla de la Juventud el tiempo de entrega es mayor que en las otras provincias.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-6" data-toggle="collapse" data-target="#collapse-comida-6" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-6" aria-expanded="false" aria-controls="collapse-comida-6">
                      ¿Qué necesita la persona en Cuba para recibir el paquete?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-6" class="collapse" aria-labelledby="heading-comida-6" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Quien reciba el paquete en Cuba deberá presentar su carnet de identidad cubano para probar que es el destinatario que usted indicó. Además, deberá revisarlo.<br>
                      Una vez el receptor acepte el paquete indicando que está conforme, no podrá hacer ningún reclamo por conceptos de daños ni de otra índole. El paquete solo se le entregará al destinatario que se designó.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-7" data-toggle="collapse" data-target="#collapse-comida-7" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-7" aria-expanded="false" aria-controls="collapse-comida-6">
                      ¿Cuánto paga en Cuba la persona que recibe el paquete?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-7" class="collapse" aria-labelledby="heading-comida-7" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Nada. Su familiar o la persona que reciba el paquete en Cuba no debe abonar ningún dinero.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-8" data-toggle="collapse" data-target="#collapse-comida-8" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-8" aria-expanded="false" aria-controls="collapse-comida-8">
                      ¿Qué productos NO se pueden enviar a Cuba?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-8" class="collapse" aria-labelledby="heading-comida-8" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      &nbsp; - Artículos que por su cantidad e independiente de su valor tengan un carácter comercial.<br>
                      &nbsp; - Artículos ocultos para burlar el control aduanero.<br>
                      &nbsp; - Estupefacientes, psicotrópicos y sustancias similares.<br>
                      &nbsp; - Productos biológicos (vacunas, medios diagnósticos o sueros de uso animal).<br>
                      &nbsp; - Alimentos que no estén en su embalaje original, con roturas o deterioro.<br>
                      &nbsp; - Leche fluida y derivados lácteos, generalmente NO PASTEURIZADOS.<br>
                      &nbsp; - Productos lácteos, lácteos sin marcas reconocidas o re-envasados.<br>
                      &nbsp; - Frutas, vegetales y cereales frescos<br>
                      &nbsp; - Productos agrícolas y forestales<br>
                      &nbsp; - Explosivos<br>
                      &nbsp; - Armas de Fuego y Municiones<br>
                      &nbsp; - Dinero en efectivo y valores de cualquier tipo<br>
                      &nbsp; - Animales vivos, texidermiados excepto caninos y felinos<br>
                      &nbsp; - Pornografía de cualquier tipo u otras literaturas que atenten contra la moral o el orden interior<br>
                      &nbsp; - Partes de cualquier tipo de plantas (hojas, ramas, raíces, tallos, tubérculos)<br>
                      &nbsp; - Semillas botánicas y agámicas<br>
                      &nbsp; - Drogas, estupefacientes y sustancias psicóticas y alucinógenas, salvo las de uso médico acompañadas por una prescripción médica<br>
                      &nbsp; - Receptores de radio profesionales (que difieran de los aparatos domésticos de radio)<br>
                      &nbsp; - Trasmisores de radio de cualquier naturaleza y servicio (radares, radiofaros, radio enlaces, buscadores de personas, de radio difusión, equipos para tele medición, telemando)<br>
                      &nbsp; - Estaciones terrestres y terminales de comunicación por satélites (Incluye las estaciones receptoras, las antenas parabólicas, sus accesorios y los teléfonos satelitales)<br>
                      &nbsp; - Transceptores de radio, equipos de estaciones fijas móviles y walkie-talkie<br>
                      &nbsp; - Drogas estupefacientes, sicotrópicas, precursores y sustancias relacionadas<br>
                      &nbsp; - Hemoderivados, vacunas humanas, antisueros, cepas de microorganismos, medios de cultivo, productos obtenidos por ingeniería genética y organismos modificados genéticamente, así como de otros productos biológicos, salvo cuando sean importados con fines científicos y cuenten con la autorización correspondiente<br>
                      &nbsp; - Equipos, dispositivos y materiales médicos, odontológicos y de diagnóstico de laboratorio y por imagenología en cantidades que sean representativas de una actividad comercial<br>
                      &nbsp; - Radioisótopos para uso de diagnóstico in vivo, radiofármacos y productos radioactivos utilizados para diagnóstico o con fines terapéuticos<br>
                      &nbsp; - Insumos para la salud en cantidades que sean representativas de una actividad comercial
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
  <!--END FAQS SECTION-->
</section>

<ng-template #snippet>
  <div class="backdrop" style="border-radius: 8px">
    <div class="text-center">
      <picture>
        <source srcset="assets/loading.webp" type="image/webp">
        <source srcset="assets/loading.gif" type="image/gif">
        <img style="height: 70px; width:70px" src="assets/imgs/loading.gif" alt="Cargando...">
      </picture>
    </div>
  </div>
</ng-template>
